import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanPhaseProjectPlanPhaseMilestoneRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseProjectPlanPhaseMilestone";
        this.parentEnterpriseComponent = "ProjectPlanPhase";
        this.childEnterpriseComponent = "ProjectPlanPhaseMilestone";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanPhaseUSID";
    }
}

export default ProjectPlanPhaseProjectPlanPhaseMilestoneRelationshipMetadata;